import { STATUS_LABELS } from "@/lib/constants";

const TONES = {
  verified: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  completed: "bg-[#F4F0EA] text-[#3D382E] border-[#C5BCAB]",
  rejected: "bg-red-50 text-red-800 border-red-200",
  withdrawn: "bg-red-50 text-red-800 border-red-200",
  available: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  under_offer: "bg-[#FFFBEB] text-[#92400E] border-[#FDE68A]",
  sold: "bg-[#F4F0EA] text-[#3D382E] border-[#C5BCAB]",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId}
    className={`inline-flex items-center px-2.5 py-1 border font-plex text-[11px] uppercase tracking-wider ${TONES[status] || "bg-[#FFFBEB] text-[#92400E] border-[#FDE68A]"}`}>
    {STATUS_LABELS[status] || status}
  </span>
);
